import React, { useEffect, useState, useRef } from "react";

import submittedImg from "../../../assets/stylesheets/static/media/submit-response.svg";
import EditableText from "../../editor/editableText";
import FileUploader from "../../shared/fileUploader";
import pollsCss from "../../../assets/styles/polls/polls.module.scss";
import _ from "lodash";
import ColorPicker from "../../shared/colorPicker";
import { PenIcon } from "../../../assets/styles/polls/icons";
import { Icon } from "semantic-ui-react";

const CustomThankYouPage = ({ draft, handleDraftChange }) => {
  const fileUploaderRef = useRef(null);

  const [thankYouIcon, setThankYouIcon] = useState(submittedImg);

  const [pageDetail, setPageDetail] = useState(() => ({
    ...draft.data.template_data.thankYouPage,
    title: draft.data.template_data.thankYouPage.title || "Thank You",
    text: draft.data.template_data.thankYouPage.text || "#606062",
    backgroundColor:
      draft.data.template_data.thankYouPage.backgroundColor || "#f6f6f6",
    description:
      draft.data.template_data.thankYouPage.description ||
      "Your feedback is valuable for us",
  }));


  useEffect(() => {
    setThankYouIcon(
      draft?.data?.template_data?.thankYouPage?.icon
        ? `${pageDetail.basePath}${draft?.data?.template_data?.thankYouPage?.icon}`
        : submittedImg
    );
  }, [draft?.data?.template_data?.thankYouPage]);


  const handleTitleChange = (value) => {
    setPageDetail((prev) => ({ ...prev, title: value }));
    handleDraftChange("data.template_data.thankYouPage.title", value);
  };

  const handleDescriptionChange = (value) => {
    setPageDetail((prev) => ({ ...prev, description: value }));
    handleDraftChange("data.template_data.thankYouPage.description", value);
  };

  const handleChangeValue = (key, value) => {
    setPageDetail((prev) => ({ ...prev, [key]: value }));
    if (key === "backgroundColor") {
      handleDraftChange(
        "data.template_data.thankYouPage.backgroundColor",
        value
      );
    }
    if (key === "text") {
      handleDraftChange("data.template_data.thankYouPage.text", value);
    }
  };

  const handlePenClick = () => {
    const fileInput =
      fileUploaderRef.current?.querySelector("input[type='file']");
    if (fileInput) {
      fileInput.click();
    }
  };

  const renderColorPicker = (key, alignment, defaultColor) => {
    const currentColor = (pageDetail && pageDetail[key]) || defaultColor;

    const formattedColor = `#${currentColor}`;
    const colorBoxStyle = {
      width: "120px",
      height: "32px",
      borderRadius: "4px",
      border: "1px solid #DCE2E3",
      backgroundColor: "white",
      display: "flex",
      alignItems: "center",
      justifyContent: "left",
      marginRight: "250px",
      color: "#222222",
      paddingLeft: "5px",
    };

    const colorPickerSectionStyle_ = {
      display: "flex",
      alignItems: "center",
      gap: "10px",
    };

    const labelStyle = {
      position: "relative",
      top: "12px",
      fontWeight: "bold",
      fontSize: "14px",
      fontFamily: "LATO",
      lineHeight: "16.8px",
    };

    const colorPickerSectionStyle = {
      display: "flex",
      flexDirection: "column",
      gap: "24px",
      width: "96%",
    };

    return (
      <div style={colorPickerSectionStyle}>
        <label style={labelStyle}>{_.upperFirst(key)} </label>
        <div style={colorPickerSectionStyle_}>
          <ColorPicker
            __id={"test" + key}
            color={currentColor}
            label={_.upperFirst(key)}
            orientation="vertical"
            alignment={alignment}
            renderAbove
            handleChangeColor={(value) => {
              handleChangeValue(key, value);
            }}
          />

          <div style={colorBoxStyle}>
            <label htmlFor={"test" + key}>{formattedColor}</label>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className={pollsCss.thankYouContainer}>
        {/* <div style={{ backgroundColor: `#${pageDetail.backgroundColor}` }}> */}
        <div>
          <div className={pollsCss.customPageInner}>
            <div className={pollsCss.iconContainerInner}>
              <div className={pollsCss.iconContainerInnerOverlay}/>
              <img src={thankYouIcon} className={pollsCss.imgWidth} />
              <div className={pollsCss.penIcon} onClick={handlePenClick}>
                <PenIcon />
              </div>
              {draft?.data?.template_data?.thankYouPage?.icon && (
                <div
                  className={pollsCss.trashIcon}
                  onClick={() =>
                    handleDraftChange(
                      "data.template_data.thankYouPage.icon",
                      ""
                    )
                  }
                >
                  <Icon name="trash alternate outline" />
                </div>
              )}
            </div>

            <div ref={fileUploaderRef} className={pollsCss.fileUploader}>
              <FileUploader
                label={"Upload Icon"}
                existingFile={draft?.data?.template_data?.thankYouPage?.icon}
                handleChange={(filePath) => {
                  handleDraftChange(
                    "data.template_data.thankYouPage.icon",
                    filePath
                  );
                }}
              />
            </div>

            <p
              className={pollsCss.heading}
              style={{ color: `#${pageDetail.text}` }}
            >
              <EditableText
                name={pageDetail.title}
                onChange={handleTitleChange}
              />
            </p>

            <p
              className={pollsCss.text}
              style={{ color: `#${pageDetail.text}` }}
            >
              <EditableText
                name={pageDetail.description}
                onChange={handleDescriptionChange}
              />
            </p>
            {/* <div className={pollsCss.pickers}>
              {renderColorPicker("backgroundColor", "center", "f6f6f6")}
              {renderColorPicker("text", "center", "606062")}
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomThankYouPage;
